import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, QueryList } from "@angular/core";
import { AppSettings } from "app/app.settings";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { List } from "underscore";
import { ChannelSourceMapEnum, EMEAEUREGIONS, Region } from "../components/einvoicing-channels/einvoicing.constants";
import { ChannelTemplateConfig, ChannelValidationRequest, EdiVanInformation, RegionChannels, SupplierChannelValidationRequest, SupplierChannelValidationResponse } from "../models/channels.model";
import { AutoInvoiceSupplierSourceMap, SearchResult, SupplierChannelPropertyValues } from "../models/supplier.model";
import { BaseService } from "./base.service";

@Injectable()
export class EInvoicingService extends BaseService {

    constructor(private http: HttpClient,
        private config: AppSettings,) {
        super();
    }

    getChannelListByCode(supplierCode: string): Observable<SupplierChannelPropertyValues[]> {
        return this.http.get<any>(`${this.config.BaseUrl}Profile/supplierinformation/` + supplierCode + '/channel', { headers: this.setHeaders() })
            .pipe(map(res => {
                return res && res.channels ? res.channels : null
            }));
    }

    getSupplierEDIVANInfo(supplierCode: string): Observable<EdiVanInformation[]> {
        return this.http.get<EdiVanInformation[]>(`${this.config.BaseUrl}Profile/EInvoicingChannels/getEDIInfo/${supplierCode}`, { headers: this.setHeaders() })
            .pipe(map(res => {
                return res ? res : null
            }));
    }

    getSupplierIDOpenChannleRequests(supplierid: number): Observable<Array<ChannelValidationRequest>> {
        return this.http.get<Array<ChannelValidationRequest>>(`${this.config.BaseUrl}Profile/EInvoicingChannels/getOpenRequest/${supplierid}`, { headers: this.setHeaders() })
            .pipe(map((res: Array<ChannelValidationRequest>) => {
                return res ? res : null;
            }))
    }

    postNewChannelValidationRequest(supplierCode: string, ChannelValidationRequest: SupplierChannelValidationRequest): Observable<SupplierChannelValidationResponse> {
        const url = `${this.config.BaseUrl}Profile/EInvoicingChannels/${supplierCode}/createRequest`;
        return this.http.post<SupplierChannelValidationResponse>(url, ChannelValidationRequest, { headers: this.setHeaders() });
    }

    /** Downlaods template file from API */
    downloadTemplate(documentId: string, version: string = null): Observable<Blob> {
        const url = `${this.config.BaseUrl}Profile/EInvoicingChannels/DownloadTemplate/${documentId}?version=${version}`;
        return this.http.get(url, { headers: this.setFileHeaders(), responseType: 'blob' });
    }

    getChannelTemplates(): Observable<ChannelTemplateConfig[]> {
        return this.http.get<ChannelTemplateConfig[]>(`${this.config.BaseUrl}Profile/EInvoicingChannels/GetChannelTemplates`, { headers: this.setHeaders() })
            .pipe(map(res => {
                return res ? res : null
            }));
    }

    validChannelsForChannelSelection(supplierChannels: AutoInvoiceSupplierSourceMap[], includePortal: boolean = false): { SourceName: string, Enabled: boolean, Supplierid: number }[] {

        const sources: { SourceName: string, Enabled: boolean, Supplierid: number }[] = []

        if (!supplierChannels) {
            return sources;
        }

        const validChannels = supplierChannels.filter(x => x.AllowChannelSelection || (includePortal && x.AutoInvoiceSupplierSourceID == ChannelSourceMapEnum.Portal));

        validChannels.forEach(x => {
            sources.push({
                SourceName: x.SupplierSourceName,
                Enabled: x.Enabled,
                Supplierid: x.SupplierId
            });
        })

        return sources;

    }

    getChannelRequestFeatureFlag(): Observable<boolean> {
        return this.http.get<boolean>(`${this.config.BaseUrl}Profile/EInvoicingChannels/IsChannelRequestEnabled`, { headers: this.setHeaders() })
            .pipe(map(res => {
                return res ? res : null
            }));
    }

    validateCXMLFiles(
        supplierCode: string,
        files: File[],
        channelType: string,
        region: string
    ): Observable<FileValidationResult[]> {
        const formData = new FormData();

        files.forEach(file => {
            formData.append('files', file, file.name);
        });
        formData.append('channelType', channelType);
        formData.append('region', region);

        let specificHeaders = new HttpHeaders();

      const url = `${this.config.BaseUrl}Profile/EInvoicingChannels/${supplierCode}/validateCXML`;

        return this.http.post<FileValidationResult[]>(
            url,
            formData,
            { headers: specificHeaders }
        ).pipe(
            map(res => {
                console.log('validateCXMLFiles response:', res);
                return res;
            })
        );
    }
}


export interface ValidationError {
    fileName: string;
    errorMessages: string[];
    // undefined means not checked yet, true means ambiguous error, false means no ambiguous error
    isAmbiguousError: boolean;
}

export interface FileValidationResult {
    fileName: string;
    isValid: boolean;
    errorMessages?: string[];
}
